import { defineComponent as _defineComponent } from 'vue'
import WarRoomPostPollResultsChoice from '@/components/partials/war-room/WarRoomPostPollV2/WarRoomPostPollV2Results/WarRoomPostPollResultsChoice.vue';
import type { IPostPoll } from '@/types/community';

type WarRoomPostPollV2ResultsProps = {
  poll: IPostPoll;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'WarRoomPostPollV2Results',
  props: {
    poll: null
  },
  setup(__props: any) {



return { __sfc: true,WarRoomPostPollResultsChoice }
}

})